export function Meta({
  label,
  value,
  icon,
}: {
  label: string;
  value: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-xl border border-[var(--dash-line)] bg-[var(--dash-soft)] px-2.5 py-2 sm:px-3 sm:py-2.5">
      <p className="m-0 flex items-center gap-1 truncate text-[10px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase sm:text-[11px]" title={label}>
        {icon}
        {label}
      </p>
      <p className="m-0 mt-0.5 break-words text-[12px] font-semibold leading-snug text-[var(--dash-ink)] sm:text-sm" title={value}>
        {value}
      </p>
    </div>
  );
}

export function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-0 rounded-xl border border-[var(--dash-line)] bg-[var(--dash-soft)] px-2.5 py-2 sm:px-3 sm:py-2.5">
      <p className="m-0 truncate text-[10px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase" title={label}>
        {label}
      </p>
      <p className="m-0 mt-0.5 truncate text-[14px] font-bold text-[var(--dash-ink)] sm:text-base" title={value}>
        {value}
      </p>
    </div>
  );
}

export function Row({
  label,
  value,
  tone,
}: {
  label: string;
  value: string;
  tone?: 'success' | 'warn';
}) {
  const valueClass =
    tone === 'success'
      ? 'text-[var(--dash-success)]'
      : tone === 'warn'
        ? 'text-amber-700'
        : 'text-[var(--dash-ink)]';
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="text-[var(--dash-muted)]">{label}</span>
      <span className={`font-semibold ${valueClass}`}>{value}</span>
    </div>
  );
}
